import { Icons } from '@/assets/icons/icons';
import { Dialog } from '@/components/ui/dialog';
import { IconButton } from '@/components/ui/IconButton';
import { XStack, YStack } from '@/components/ui/layout/layout';

type AgentInboxDialogHeaderProps = {
  title: string;
  description: React.ReactNode;
  onBack?: () => void;
};

export const AgentInboxDialogHeader = ({
  title,
  description,
  onBack,
}: AgentInboxDialogHeaderProps) => (
  <XStack className="shrink-0 items-start gap-2 px-6 pb-4 pr-12 pt-6">
    {onBack && (
      <IconButton
        icon={Icons.chevronLeft}
        size="sm"
        variant="ghost"
        tooltip="Back"
        aria-label="Back"
        className="-ml-2 mt-0.5 shrink-0"
        onClick={onBack}
      />
    )}
    <YStack className="min-w-0 gap-1">
      <Dialog.Title className="truncate">{title}</Dialog.Title>
      <Dialog.Description className="text-sm text-foreground-muted">
        {description}
      </Dialog.Description>
    </YStack>
  </XStack>
);
